import React from "react";

const Logo = () => {
  return (
    <img
      src={process.env.PUBLIC_URL + "/assets/images/logo/logo-3.png"}
      alt="logo"
    />
  );
};

export default Logo;
